import {
  Box,
  Container,
  Grid,
  Typography,
  useMediaQuery,
  // Button,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import styles from './styles';

const NavBar = ({
  backButtonText,
  forwardButtonText,
  backButtonOnClick,
  nextButtonOnClick,
  disableBack = false,
  disableNext = false,
  // fadeEffect = false,
  headerText,
  additionalStyles,
  headerIcon,
  backArrowIcon,
  forwardArrowIcon,
  buttonPositionToLeft,
}) => {
  const theme = useTheme();
  const style = styles(theme);
  const sm = useMediaQuery(theme.breakpoints.down('sm'));
  const md = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  const backButtonSelect = () => {
    backButtonOnClick();
  };
  const nextButtonSelect = () => {
    nextButtonOnClick();
  };

  return (
    <Box
      sx={
        // fadeEffect ? style.fadedContainer :
        style.container
      }
    >
      <Container maxWidth='lg' disableGutters>
        <Grid
          container
          justifyContent={!backButtonText || !forwardButtonText ? 'center' : 'space-between'}
          alignItems='center'
          sx={additionalStyles ? style.navBarStepperContainer : style.navBarContainer}
        >
          {backButtonText && (
            <Grid item xs={3} sm={3} sx={disableBack === true ? style.disableButton : ''}>
              <Box
                sx={style.leftButton}
                onClick={() => {
                  backButtonSelect();
                }}
              >
                {backArrowIcon}
                <Typography variant='subtitle1' sx={style.backButtonText}>
                  {backButtonText}
                </Typography>
              </Box>
            </Grid>
          )}
          {!sm && (
            <Grid
              item
              xs={6}
              sm={md && additionalStyles ? 12 : 6}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: theme.palette.secondary.contrastText,
              }}
            >
              {headerIcon}
              {headerText}
            </Grid>
          )}
          {/* When butttonPositionLeft is true it means we have to disbale 
          forward button and only back button is visible, it is done mainly for installation page */}
          {forwardButtonText && !buttonPositionToLeft && (
            <Grid item xs={3} sm={3} sx={disableNext === true ? style.disableButton : ''}>
              <Box
                sx={style.rightButton}
                onClick={() => {
                  nextButtonSelect();
                }}
              >
                <Typography variant='subtitle3' sx={style.nextButtonText}>
                  {forwardButtonText}
                </Typography>
                {forwardArrowIcon}
              </Box>
            </Grid>
          )}
        </Grid>
      </Container>
      {sm && (
        <Grid
          item
          flexDirection={additionalStyles ? 'column' : 'rows'}
          xs={6}
          sm={6}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: additionalStyles ? '0px 0px 8px' : '4px 0',
            color: theme.palette.secondary.contrastText,
          }}
        >
          {headerIcon}
          {headerText}
        </Grid>
      )}
    </Box>
  );
};

export default NavBar;
